<section>
  <div class="wrapper">
    <!--HEADING-->
    <h2>Videos</h2>
    <!--END HEADING-->
    <!--MESSAGE-->
    <p class="margin-top-large">
      New to training or not yet a subscriber? Sample some of our eLearning content that covers a
      variety of topics related to the contact center industry.
    </p>
    <!--END MESSAGE-->
    <!--SHARED FEATURED & RECOMMENDED VIDEOS-->
    <app-featured-videos [isHomePageRecommendedVideos]="true"></app-featured-videos>
    <!--END SHARED FEATURED & RECOMMENDED VIDEOS-->
    <!--MORE VIDEOS CTA-->
    <div class="text-align-center margin-top-small">
      <app-route-button
        id="promoted-videos-see-all-videos"
        [actionButtonCss]="'action-button'"
        [attr.data-beyond-button-id]="'promoted-videos-see-all-videos'"
        [route]="'videos'"
        (click)="sendGoogleAnalytics('videos', 'click', 'See All Videos')"
        [actionLabel]="'See All Videos'"
        [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small']">
      </app-route-button>
    </div>
    <!--END MORE VIDEOS CTA-->
  </div>
</section>
